/**
 * Issues Processor - issues grouped deviceId,
 * must be taken from the AppInstancesRepository
 */
import { AppInstancesRepository, DevicesRepository } from 'common/repositories/index';

let processedIssues = [];
const observableProcessedIssues = new Rx.BehaviorSubject(processedIssues);
const subjectAppInstancesRepository = AppInstancesRepository.getObservable();
const subjectDevicesRepository = DevicesRepository.getObservable();
/**
 * @ngdoc service
 * @name processors.IssuesProcessor
 *
 * @description
 * IssuesProcessor.
 */
const IssuesProcessor = {

    /**
     * Replace all instances with received data
     * @param {Array} data
     */
    onNext(data) {

        processedIssues = [];
        data.forEach((appInstance) => {

            if (this._hasIssueOn(appInstance)) {

                this.addIssue(appInstance);

            }

        });

        observableProcessedIssues.onNext(processedIssues);

    },

    _hasIssueOn(instance) {

        // Get device by instance
        let device;
        if (instance.relationships.device) {

            device = DevicesRepository.getById(instance.relationships.device.data.id);

        }

        // Detect issues only if the device is online/offline
        if (device && (device.attributes.state === 'online' ||
                           device.attributes.state === 'offline') &&
                          (!device.attributes.hidden)) {

            if (instance.attributes.status.svc &&
                    instance.attributes.app_status === 'not_protected' &&
                    (instance.attributes.status.svc.guard !== 1 ||
                    instance.attributes.status.svc.firewall !== 1 ||
                    instance.attributes.status.svc.mailguard !== 1 ||
                    instance.attributes.status.svc.webguard !== 1) &&
                    instance.attributes.state === 'active') {

                return true;

            }

        }
        return false;

    },

    /**
     * Add issue based on its deviceId
     * @param appInstance
     */
    addIssue(appInstance) {

        const deviceId = appInstance.relationships.device.data.id;
        processedIssues[deviceId] = appInstance;

    },

    /**
     * @ngdoc function
     * @name processors.IssuesProcessor#getAll
     * @methodOf processors.IssuesProcessor
     * @function
     *
     * @description
     * This function can be used to retun all processed issues.
     *
     * @returns {Array} all processed issues
     */
    getAll() {

        return processedIssues;

    },

    getObservable() {

        return observableProcessedIssues;

    },

};

// subscribe on instances changes

subjectAppInstancesRepository.subscribe(
    data => IssuesProcessor.onNext(data),
    () => { },
    () => { },
);

// subscribe on devices changes

subjectDevicesRepository.subscribe(
    () => {

        subjectAppInstancesRepository.onNext(AppInstancesRepository.getAll());

    },
    () => { },
    () => { },
);

export default IssuesProcessor;



// WEBPACK FOOTER //
// ./scripts/common/repositoryProcessors/-RFC.issuesProcessor.js